import { FC, ReactNode } from 'react';

import styles from './index.module.scss';

type SignUpLayoutProps = {
	children: ReactNode;
};

export const Login2FALayout: FC<SignUpLayoutProps> = ({ children }) => {
	return (
		<div className={styles.root}>
			<div className={styles.center}>
				<div className={styles.content}>{children}</div>
			</div>
		</div>
	);
};
